import { sb } from '../../../supabase.ts';
import { escapeHtml } from '../../../main.ts';

export async function renderOtherSchoolTcEditFormPage(app: HTMLElement): Promise<void> {
  const terminationTable = 'termination_table_others';
  const currentUser = localStorage.getItem('adminButton') || 'admin';

  // Retrieve URL parameter iid
  const urlParams = new URLSearchParams(window.location.search);
  const iidParam = urlParams.get('iid') || '';

  app.innerHTML = `
    <style>
      .edit-wrap {
        background: radial-gradient(circle at 50% 50%, rgba(16, 185, 129, 0.02), transparent 45%), linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        color: #334155;
        font-family: 'Outfit', 'Segoe UI', sans-serif;
        min-height: 100vh;
        padding-bottom: 40px;
      }
      .edit-header {
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(8px);
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        padding: 16px 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .edit-header h1 {
        font-size: 20px;
        margin: 0;
        font-weight: 800;
        color: #0f172a;
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .back-btn {
        color: #10b981;
        text-decoration: none;
        margin-right: 12px;
        font-size: 20px;
        font-weight: bold;
        transition: transform 0.2s;
        display: inline-block;
      }
      .back-btn:hover {
        transform: translateX(-3px);
      }
      .form-container {
        padding: 24px;
        max-width: 900px;
        margin: 0 auto;
      }
      .card-premium {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.08);
        border-radius: 16px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
        padding: 28px;
      }
      .grid-layout {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
        gap: 16px;
      }
      .form-group {
        display: flex;
        flex-direction: column;
        gap: 6px;
      }
      .form-group.full-width {
        grid-column: 1 / -1;
      }
      .form-group label {
        font-size: 11px;
        font-weight: 700;
        color: #64748b;
        text-transform: uppercase;
        letter-spacing: 0.05em;
      }
      .form-group input, .form-group select, .form-group textarea {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.12);
        border-radius: 8px;
        color: #0f172a;
        padding: 11px 14px;
        font-size: 14px;
        outline: none;
        transition: border-color 0.2s, box-shadow 0.2s;
      }
      .form-group input:focus, .form-group select:focus, .form-group textarea:focus {
        border-color: #10b981;
        box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
      }
      .form-actions {
        margin-top: 24px;
        display: flex;
        gap: 12px;
        align-items: center;
      }
      .primary-btn {
        background: linear-gradient(135deg, #10b981, #059669);
        color: #ffffff;
        border: none;
        border-radius: 8px;
        padding: 12px 24px;
        font-size: 14px;
        font-weight: 700;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 6px;
        transition: all 0.2s;
      }
      .primary-btn:hover {
        opacity: 0.95;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
      }
      .secondary-btn {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.12);
        color: #475569;
        border-radius: 8px;
        padding: 12px 20px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        text-decoration: none;
        transition: all 0.2s;
        display: inline-block;
        text-align: center;
      }
      .secondary-btn:hover {
        background: #f8fafc;
        border-color: rgba(0, 0, 0, 0.2);
        color: #0f172a;
      }
      .status-banner {
        padding: 12px 16px;
        border-radius: 8px;
        margin-bottom: 20px;
        font-size: 13px;
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .status-info {
        background: rgba(59, 130, 246, 0.05);
        border: 1px solid rgba(59, 130, 246, 0.15);
        color: #2563eb;
      }
      .status-success {
        background: rgba(16, 185, 129, 0.05);
        border: 1px solid rgba(16, 185, 129, 0.15);
        color: #059669;
      }
      .status-error {
        background: rgba(239, 68, 68, 0.05);
        border: 1px solid rgba(239, 68, 68, 0.15);
        color: #dc2626;
      }
      .search-box {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
        padding: 20px;
        margin-bottom: 24px;
        display: flex;
        gap: 12px;
        align-items: flex-end;
      }
      .search-box input {
        padding: 10px 14px;
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.12);
        border-radius: 8px;
        color: #0f172a;
        font-size: 14px;
        outline: none;
        flex: 1;
        transition: border-color 0.2s;
      }
      .search-box input:focus {
        border-color: #10b981;
      }
      .table-card {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.08);
        border-radius: 16px;
        box-shadow: 0 10px 30px rgba(0,0,0,0.03);
        overflow: hidden;
      }
      .tc-table {
        width: 100%;
        border-collapse: collapse;
        text-align: left;
      }
      .tc-table th {
        background: rgba(248, 250, 252, 0.9);
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        padding: 14px 16px;
        font-size: 13px;
        font-weight: 700;
        color: #64748b;
        text-transform: uppercase;
        letter-spacing: 0.05em;
      }
      .tc-table td {
        padding: 12px 16px;
        font-size: 14px;
        color: #334155;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
      }
      .tc-table tbody tr:hover {
        background: rgba(0, 0, 0, 0.01);
      }
      .status-badge {
        font-size: 10px;
        font-weight: 800;
        text-transform: uppercase;
        padding: 3px 8px;
        border-radius: 12px;
        letter-spacing: 0.05em;
      }
      .action-link {
        color: #10b981;
        text-decoration: none;
        font-weight: 700;
        transition: color 0.2s;
      }
      .action-link:hover {
        color: #059669;
        text-decoration: underline;
      }
      .sep {
        color: rgba(0, 0, 0, 0.15);
        margin: 0 8px;
      }
      .count-badge {
        background: rgba(16, 185, 129, 0.1);
        color: #059669;
        padding: 2px 8px;
        border-radius: 20px;
        font-size: 12px;
        font-weight: 700;
      }
    </style>

    <div class="edit-wrap">
      <div class="edit-header">
        <h1>
          <a href="/other_school/tc/test_list" class="back-btn">←</a>
          Edit Transfer Certificate Record
        </h1>
        <div style="font-size: 13px; color: #64748b; font-weight: 600; display: flex; align-items: center; gap: 12px;">
          <a href="#" id="viewCertLink" class="secondary-btn" style="padding: 6px 12px; font-size: 12px; border-color: rgba(16, 185, 129, 0.3); color: #10b981;" target="_blank">View Certificate ↗</a>
          <span>User: <span style="color: #10b981;">${escapeHtml(currentUser)}</span></span>
        </div>
      </div>

      <div class="form-container">
        <div class="search-box">
          <div style="flex: 1; display: flex; flex-direction: column; gap: 6px;">
            <label style="font-size: 12px; font-weight: 600; color: #64748b; text-transform: uppercase;">Search by Student IID</label>
            <input type="number" id="searchIid" placeholder="Enter Student IID..." value="${escapeHtml(iidParam)}" />
          </div>
          <button id="searchBtn" class="primary-btn" style="padding: 10px 20px; height: 42px;">Load TC</button>
        </div>

        <div class="status-banner status-info" id="statusBanner">
          <span>ℹ️</span>
          <span id="statusMsg">Loading Transfer Certificate record details...</span>
        </div>

        <div class="card-premium">
          <form id="tcEditForm" style="display: none;">
            <div class="grid-layout">
              <div class="form-group">
                <label>Student Name *</label>
                <input type="text" name="name" id="name" required />
              </div>
              <div class="form-group">
                <label>Father's Name</label>
                <input type="text" name="father" id="father" />
              </div>
              <div class="form-group">
                <label>Mother's Name</label>
                <input type="text" name="mother" id="mother" />
              </div>
              <div class="form-group">
                <label>Class</label>
                <select name="tc_class" id="tc_class">
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                </select>
              </div>
              <div class="form-group">
                <label>Section</label>
                <select name="tc_section" id="tc_section">
                  <option value="Shapla">Shapla</option>
                  <option value="Golap">Golap</option>
                  <option value="Morning">Morning</option>
                </select>
              </div>
              <div class="form-group">
                <label>Roll</label>
                <input type="text" name="tc_roll" id="tc_roll" />
              </div>
              <div class="form-group">
                <label>Registration No</label>
                <input type="text" name="board_registration" id="board_registration" />
              </div>
              <div class="form-group">
                <label>Date of Birth</label>
                <input type="text" name="student_dateofbirth" id="student_dateofbirth" placeholder="DD-MM-YYYY" />
              </div>
              <div class="form-group">
                <label>Gender</label>
                <select name="student_gender" id="student_gender">
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div class="form-group">
                <label>Paid Upto *</label>
                <select name="paid_month" id="paid_month"></select>
              </div>
              <div class="form-group">
                <label>Character *</label>
                <select name="student_character" id="student_character">
                  <option value="good">good</option>
                  <option value="very good">very good</option>
                  <option value="bad">bad</option>
                  <option value="very bad">very bad</option>
                </select>
              </div>
              <div class="form-group">
                <label>Next Class *</label>
                <select name="next_class" id="next_class">
                  <option value=""></option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                </select>
              </div>
              <div class="form-group">
                <label>Session</label>
                <select name="tc_session" id="tc_session">
                  <option value="2023">2023</option>
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                </select>
              </div>
              <div class="form-group">
                <label>Issued By *</label>
                <select name="issued_by" id="issued_by">
                  <option value="RAZIB KUMAR PAUL">RAZIB KUMAR PAUL</option>
                  <option value="SHOWRAV DEB">SHOWRAV DEB</option>
                </select>
              </div>
              <div class="form-group">
                <label>Father's Mobile</label>
                <input type="text" name="father_mobile" id="father_mobile" placeholder="Mobile prefix 880" />
              </div>
              <div class="form-group">
                <label>TC Date *</label>
                <input type="text" name="tc_date" id="tc_date" required placeholder="DD-MM-YYYY" />
              </div>
              <div class="form-group full-width">
                <label>Note / Remarks</label>
                <textarea name="note" id="note" rows="3" placeholder="Remarks or reasons..."></textarea>
              </div>
            </div>
            <div class="form-actions">
              <button type="submit" class="primary-btn">Save Changes</button>
              <a href="/other_school/tc/test_list" class="secondary-btn">Cancel</a>
            </div>
          </form>
        </div>

        <div class="table-card" style="margin-top: 30px;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; flex-wrap: wrap; gap: 12px; padding: 20px 20px 0 20px;">
            <h2 style="font-size: 16px; font-weight: 800; color: #0f172a; margin: 0; display: flex; align-items: center; gap: 8px;">
              <span>📋</span> Previous Transfer Certificate Records
              <span class="count-badge" id="tcCountVal">0</span>
            </h2>
            <div style="position: relative; width: 250px;">
              <input type="text" id="tableSearchInput" placeholder="Filter previous records..." style="width: 100%; padding: 8px 12px; background: #ffffff; border: 1px solid rgba(0, 0, 0, 0.12); border-radius: 8px; color: #0f172a; font-size: 13px; outline: none; transition: border-color 0.2s;" />
            </div>
          </div>
          <div style="overflow-x: auto; padding: 0 20px 20px 20px;">
            <table class="tc-table">
              <thead>
                <tr>
                  <th>TC Serial</th>
                  <th>Name</th>
                  <th>Class (Roll)</th>
                  <th>Student IID</th>
                  <th>TC Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody id="tcRecordsTableBody">
                <tr>
                  <td colspan="6" style="text-align: center; color: #64748b; padding: 20px; font-size: 13px;">Loading Transfer Certificate records...</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  `;

  // DOM Elements
  const statusBanner = document.getElementById('statusBanner')!;
  const statusMsg = document.getElementById('statusMsg')!;
  const formEl = document.getElementById('tcEditForm') as HTMLFormElement;
  const viewCertLink = document.getElementById('viewCertLink') as HTMLAnchorElement;
  const searchIid = document.getElementById('searchIid') as HTMLInputElement;
  const searchBtn = document.getElementById('searchBtn') as HTMLButtonElement;

  searchBtn.onclick = () => {
    const iid = searchIid.value.trim();
    if (iid) {
      window.location.href = `/other_school/tc/tc_edit_form?iid=${encodeURIComponent(iid)}`;
    } else {
      setBanner('error', 'Please enter a valid Student IID to search.');
    }
  };

  searchIid.onkeydown = (e) => {
    if (e.key === 'Enter') searchBtn.click();
  };

  // Initialize Paid Month Options dynamically
  function buildPaidMonthOptions() {
    const sel = document.getElementById('paid_month') as HTMLSelectElement;
    if (!sel) return;
    sel.innerHTML = '';
    const years = [2025, 2026, 2027];
    const months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    for (const y of years) {
      for (const m of months) {
        const opt = document.createElement('option');
        opt.value = `${m} ${y}`;
        opt.textContent = `${m} ${y}`;
        sel.appendChild(opt);
      }
    }
  }

  function setBanner(type: 'info' | 'success' | 'error', text: string) {
    statusBanner.className = `status-banner status-${type}`;
    statusMsg.textContent = text;
    if (type === 'info') statusBanner.children[0].textContent = 'ℹ️';
    else if (type === 'success') statusBanner.children[0].textContent = '✔️';
    else statusBanner.children[0].textContent = '⚠️';
  }

  async function loadRecord() {
    if (!iidParam) {
      setBanner('info', "Enter a Student IID in the search box above to load and edit their TC record.");
      formEl.style.display = 'none';
      viewCertLink.style.display = 'none';
      return;
    }

    const iidNum = parseFloat(iidParam);
    if (isNaN(iidNum)) {
      setBanner('error', `Invalid Student IID format: '${iidParam}'`);
      formEl.style.display = 'none';
      viewCertLink.style.display = 'none';
      return;
    }

    try {
      // 1. Try fetching from termination_table_others
      const { data, error } = await sb.from(terminationTable)
        .select('*')
        .eq('iid', iidNum)
        .limit(1);

      if (error) throw error;

      if (data && data.length > 0) {
        const rec = data[0];

        // Update View Certificate link
        viewCertLink.href = `/other_school/tc/certificate_word?iid=${encodeURIComponent(rec.iid)}`;

        // Populate Form Fields
        (document.getElementById('name') as HTMLInputElement).value = rec.student_name_en || '';
        (document.getElementById('father') as HTMLInputElement).value = rec.father_name_en || '';
        (document.getElementById('mother') as HTMLInputElement).value = rec.mother_name_en || '';
        (document.getElementById('tc_class') as HTMLSelectElement).value = rec.tc_class || '6';
        (document.getElementById('tc_section') as HTMLSelectElement).value = rec.tc_section || 'Shapla';
        (document.getElementById('tc_roll') as HTMLInputElement).value = rec.tc_roll || '';
        (document.getElementById('board_registration') as HTMLInputElement).value = rec.board_registration || '';
        (document.getElementById('student_dateofbirth') as HTMLInputElement).value = rec.student_dateofbirth || '';
        (document.getElementById('student_gender') as HTMLSelectElement).value = rec.student_gender || 'Male';
        (document.getElementById('paid_month') as HTMLSelectElement).value = rec.paid_month || 'December 2025';
        (document.getElementById('student_character') as HTMLSelectElement).value = rec.student_character || 'very good';
        (document.getElementById('next_class') as HTMLSelectElement).value = rec.next_class || '';
        (document.getElementById('tc_session') as HTMLSelectElement).value = rec.tc_session || '2025';
        (document.getElementById('issued_by') as HTMLSelectElement).value = rec.issued_by || 'RAZIB KUMAR PAUL';
        (document.getElementById('father_mobile') as HTMLInputElement).value = rec.father_mobile || '';
        (document.getElementById('tc_date') as HTMLInputElement).value = rec.tc_date || '';
        (document.getElementById('note') as HTMLTextAreaElement).value = rec.note || '';

        // Reveal form
        formEl.style.display = 'grid';
        setBanner('success', `TC Record for IID ${rec.iid} (SL ${rec.tc_sl ?? '-'}) loaded successfully.`);
      } else {
        // 2. Fallback to student_database_others
        const { data: studentData, error: studentError } = await sb.from('student_database_others')
          .select('*')
          .eq('iid', iidNum)
          .limit(1);

        if (studentError) throw studentError;
        if (!studentData || !studentData.length) {
          setBanner('error', `Transfer Certificate and Student records for Student IID '${iidParam}' were not found.`);
          return;
        }

        const stu = studentData[0];
        const session = stu.session || 2025;

        // Update View Certificate link
        viewCertLink.href = `/other_school/tc/certificate_word?iid=${encodeURIComponent(stu.iid)}`;

        // Populate Form Fields from student profile
        (document.getElementById('name') as HTMLInputElement).value = stu.student_name_en || stu.name_en || '';
        (document.getElementById('father') as HTMLInputElement).value = stu.father_name_en || '';
        (document.getElementById('mother') as HTMLInputElement).value = stu.mother_name_en || '';
        (document.getElementById('tc_class') as HTMLSelectElement).value = stu[`class_${session}`] || stu.class || '6';
        (document.getElementById('tc_section') as HTMLSelectElement).value = stu[`section_${session}`] || stu.section || 'Shapla';
        (document.getElementById('tc_roll') as HTMLInputElement).value = stu[`roll_${session}`] || stu.roll || '';
        (document.getElementById('board_registration') as HTMLInputElement).value = stu.board_registration || '';
        (document.getElementById('student_dateofbirth') as HTMLInputElement).value = stu.student_dateofbirth || '';
        (document.getElementById('student_gender') as HTMLSelectElement).value = stu.student_gender || 'Male';
        (document.getElementById('paid_month') as HTMLSelectElement).value = 'December 2025';
        (document.getElementById('student_character') as HTMLSelectElement).value = 'very good';
        (document.getElementById('next_class') as HTMLSelectElement).value = '';
        (document.getElementById('tc_session') as HTMLSelectElement).value = String(session);
        (document.getElementById('issued_by') as HTMLSelectElement).value = 'RAZIB KUMAR PAUL';
        (document.getElementById('father_mobile') as HTMLInputElement).value = stu.father_mobile || stu.guardian_mobile || '';
        
        let formattedDate = stu.tc_date || '';
        if (!formattedDate) {
          const d = new Date();
          const dd = String(d.getDate()).padStart(2, '0');
          const mm = String(d.getMonth() + 1).padStart(2, '0');
          const yyyy = d.getFullYear();
          formattedDate = `${dd}-${mm}-${yyyy}`;
        }
        (document.getElementById('tc_date') as HTMLInputElement).value = formattedDate;
        (document.getElementById('note') as HTMLTextAreaElement).value = stu.comment_school || '';

        // Reveal form
        formEl.style.display = 'grid';
        setBanner('info', `Found student profile in database. You can now save their TC record.`);
      }
    } catch (e: any) {
      console.error(e);
      setBanner('error', 'Failed to retrieve record. Database error.');
    }
  }

  // Handle Form Submission
  formEl.onsubmit = async (e) => {
    e.preventDefault();
    setBanner('info', 'Saving Transfer Certificate updates...');

    const iidNum = parseFloat(iidParam);
    if (isNaN(iidNum)) {
      setBanner('error', 'Invalid Student IID. Save aborted.');
      return;
    }

    const payload = {
      student_name_en: (document.getElementById('name') as HTMLInputElement).value.trim(),
      father_name_en: (document.getElementById('father') as HTMLInputElement).value.trim(),
      mother_name_en: (document.getElementById('mother') as HTMLInputElement).value.trim(),
      tc_class: (document.getElementById('tc_class') as HTMLSelectElement).value,
      tc_section: (document.getElementById('tc_section') as HTMLSelectElement).value,
      tc_roll: (document.getElementById('tc_roll') as HTMLInputElement).value.trim(),
      board_registration: (document.getElementById('board_registration') as HTMLInputElement).value.trim(),
      student_dateofbirth: (document.getElementById('student_dateofbirth') as HTMLInputElement).value.trim(),
      student_gender: (document.getElementById('student_gender') as HTMLSelectElement).value,
      paid_month: (document.getElementById('paid_month') as HTMLSelectElement).value,
      student_character: (document.getElementById('student_character') as HTMLSelectElement).value,
      next_class: (document.getElementById('next_class') as HTMLSelectElement).value,
      tc_session: (document.getElementById('tc_session') as HTMLSelectElement).value,
      father_mobile: (document.getElementById('father_mobile') as HTMLInputElement).value.trim(),
      tc_date: (document.getElementById('tc_date') as HTMLInputElement).value.trim(),
      issued_by: (document.getElementById('issued_by') as HTMLSelectElement).value,
      note: (document.getElementById('note') as HTMLTextAreaElement).value.trim()
    };

    // Mobile Prefix 880 validation rule
    if (payload.father_mobile && !payload.father_mobile.startsWith('880')) {
      alert("Mobile number must start with country code '880'.");
      setBanner('error', "Validation Failed: Father's Mobile must start with '880'.");
      return;
    }

    try {
      // 1. Check if TC already exists in termination_table_others
      const { data: existTc, error: existErr } = await sb.from(terminationTable)
        .select('iid')
        .eq('iid', iidNum)
        .limit(1);

      if (existErr) throw existErr;

      let savedSl = null;

      if (existTc && existTc.length > 0) {
        // Update existing record
        const { error } = await sb.from(terminationTable)
          .update(payload)
          .eq('iid', iidNum);

        if (error) throw error;
        setBanner('success', 'Transfer Certificate details successfully updated!');
      } else {
        // Insert new record
        const { data: inserted, error } = await sb.from(terminationTable)
          .insert({ iid: iidNum, ...payload })
          .select('tc_sl')
          .single();

        if (error) throw error;
        savedSl = inserted?.tc_sl;
        setBanner('success', 'Transfer Certificate record successfully created!');
      }

      // 2. Keep student_database_others in sync (status='TC', tc_date, tc_no)
      const studentUpdate: any = {
        status: 'TC',
        tc_date: payload.tc_date || null
      };
      if (savedSl) {
        studentUpdate.tc_no = savedSl;
      }
      
      const { error: stuErr } = await sb.from('student_database_others')
        .update(studentUpdate)
        .eq('iid', iidNum);

      if (stuErr) {
        console.warn('Sync to student database failed:', stuErr);
      }
      await loadPreviousTcTable();
    } catch (err: any) {
      console.error(err);
      setBanner('error', 'Failed to save record. Database write error.');
    }
  };

  // Load Previous TCs into the Table
  async function loadPreviousTcTable() {
    const tcRecordsTableBody = document.getElementById('tcRecordsTableBody')!;
    const tcCountVal = document.getElementById('tcCountVal')!;
    const tableSearchInput = document.getElementById('tableSearchInput') as HTMLInputElement;

    let previousRecords: any[] = [];

    try {
      // 1. Fetch from termination_table_others
      const { data: tcData, error: tcError } = await sb.from(terminationTable)
        .select('*');

      if (tcError) throw tcError;

      // 2. Fetch from student_database_others where status = 'TC'
      const { data: studentData, error: studentError } = await sb.from('student_database_others')
        .select('*')
        .eq('status', 'TC');

      if (studentError) throw studentError;

      const tcList = tcData || [];
      const tcIids = new Set(tcList.map(r => Number(r.iid)));

      // Merge virtual records from student_database_others
      const mergedList = [...tcList];
      if (studentData) {
        for (const stu of studentData) {
          const stuIid = Number(stu.iid);
          if (!tcIids.has(stuIid)) {
            const session = stu.session || 2025;
            mergedList.push({
              tc_sl: stu.tc_no ? parseInt(stu.tc_no, 10) : null,
              student_name_en: stu.student_name_en || stu.name_en || '',
              father_name_en: stu.father_name_en || '',
              tc_class: stu[`class_${session}`] || stu.class || '',
              tc_roll: stu[`roll_${session}`] || stu.roll || '',
              iid: stu.iid,
              tc_date: stu.tc_date || '',
              note: stu.comment_school || '',
              isVirtual: true
            });
          }
        }
      }

      // Sort by tc_sl descending
      mergedList.sort((a, b) => {
        const slA = a.tc_sl ? Number(a.tc_sl) : 0;
        const slB = b.tc_sl ? Number(b.tc_sl) : 0;
        return slB - slA;
      });

      previousRecords = mergedList;
      renderTableRows(previousRecords);
    } catch (e: any) {
      console.error('Error loading previous records table:', e);
      tcRecordsTableBody.innerHTML = `
        <tr>
          <td colspan="6" style="text-align: center; color: #dc2626; padding: 20px; font-weight: 700;">
            Failed to load previous records.
          </td>
        </tr>
      `;
    }

    function renderTableRows(records: any[]) {
      tcCountVal.textContent = String(records.length);
      if (!records.length) {
        tcRecordsTableBody.innerHTML = `
          <tr>
            <td colspan="6" style="text-align: center; color: #64748b; padding: 20px;">No Transfer Certificate records found.</td>
          </tr>
        `;
        return;
      }

      tcRecordsTableBody.innerHTML = records.map(rec => `
        <tr>
          <td style="font-weight: 700; color: #059669;">${escapeHtml(String(rec.tc_sl ?? '-'))}</td>
          <td style="font-weight: 600; color: #0f172a;">${escapeHtml(String(rec.student_name_en ?? ''))}</td>
          <td>
            <span class="status-badge" style="background: rgba(37, 99, 235, 0.05); color: #2563eb; border: 1px solid rgba(37, 99, 235, 0.15);">
              Class ${escapeHtml(String(rec.tc_class ?? ''))} (${escapeHtml(String(rec.tc_roll ?? '-'))})
            </span>
          </td>
          <td>
            <a href="/other_school/edit_details?iid=${encodeURIComponent(String(rec.iid))}" class="action-link" style="color: #2563eb;">${escapeHtml(String(rec.iid ?? ''))}</a>
          </td>
          <td style="font-weight: 600; color: #475569;">${escapeHtml(String(rec.tc_date ?? '-'))}</td>
          <td>
            <a href="/other_school/tc/tc_edit_form?iid=${encodeURIComponent(String(rec.iid))}" class="action-link">Edit</a>
            <span class="sep">|</span>
            <a href="/other_school/tc/certificate_word?iid=${encodeURIComponent(String(rec.iid))}" target="_blank" class="action-link" style="color: #d97706;">Print</a>
          </td>
        </tr>
      `).join('');
    }

    // Filter Search for Table
    tableSearchInput.addEventListener('input', () => {
      const q = tableSearchInput.value.toLowerCase().trim();
      if (!q) {
        renderTableRows(previousRecords);
        return;
      }
      const filtered = previousRecords.filter(rec => 
        String(rec.student_name_en || '').toLowerCase().includes(q) ||
        String(rec.tc_class || '').toLowerCase().includes(q) ||
        String(rec.tc_roll || '').toLowerCase().includes(q) ||
        String(rec.iid || '').toLowerCase().includes(q) ||
        String(rec.tc_sl || '').toLowerCase().includes(q) ||
        String(rec.tc_date || '').toLowerCase().includes(q)
      );
      renderTableRows(filtered);
    });
  }

  buildPaidMonthOptions();
  await loadRecord();
  await loadPreviousTcTable();
}
